import { Modal, ModalContent, ModalBody, Spinner } from "@heroui/react"

const LoadingModal = ({ modal, text }) => {
  return <Modal isOpen={modal.isOpen} isDismissable={false} hideCloseButton={true}>
    <ModalContent>
      <ModalBody className='bg-chTan-200 text-chTan-800 text-center'>
        <div className='mt-8 mb-8'>
          {text && <div className='text-lg mb-6'>{text}</div>}
          <Spinner variant="spinner" size='lg' />
        </div>
      </ModalBody>
    </ModalContent>
  </Modal>
}

export default LoadingModal
